{
  "name": "18-Oliveros Septimal-Quintal",
  "description": "JI tuning system for Pauline Oliveros' accordion (May 1987). The left hand is tuned in 5 limit and the right hand is in 7 limit. The tuning was done by Walter Vergini of Oxnard, CA under the supervision of Alfred Shabda Owen. The tuning system was suggested by Loren Rush.",
  "scale": [
    "135/128",
    "16/15",
    "9/8",
    "7/6",
    "6/5",
    "5/4",
    "4/3",
    "45/32",
    "64/45",
    "3/2",
    "14/9",
    "8/5",
    "5/3",
    "27/16",
    "7/4",
    "16/9",
    "15/8",
    "15/8",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "18-JI-7L",
  "built_in_group": "Rational Intonation (JI)",
  "key_labels": "heji",
  "fundamental_color": "#f2e3e3",
  "note_names": [
    "C",
    "C",
    "D",
    "D",
    "E",
    "E",
    "E",
    "F",
    "F",
    "G",
    "G",
    "A",
    "A",
    "A",
    "A",
    "B",
    "B",
    "B",
    "C"
  ],
  "note_colors": [
    "#ffffff",
    "#fffae5",
    "#dee2da",
    "#ffffff",
    "#ffe5e5",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#fffae5",
    "#dee2da",
    "#ffffff",
    "#ffe5e5",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#d0d0d7",
    "#fffae5",
    "#fffae5"
  ],
  "equivSteps": 19,
  "fundamental": 441,
  "reference_degree": 14,
  "center_degree": 0,
  "rSteps": 3,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 27,
  "lumatone_anchor_channel": 3
}
